import { apiFunction } from "../../apiCall/function"

// Public lookup — no login token. It previously sent one, so a visitor's stale
// session could ride along on a request that never needed it.
export const getCertInfo = async (data) => {
  return await apiFunction("certificate/verify", "post", data, false, 'body')
}
